import { throttle } from 'lodash-es';
import Cookies from 'js-cookie';

export const Helpers = (function () {
	'use strict';

	function init() {
		dynamicCSSVars(); 
		body_scroll();
	}

	function dynamicCSSVars() {
		let vh = window.innerHeight * 0.01;
		let headerContainer = document.querySelector('.site-header__container');

		if(!headerContainer) return;
		let headerSize = headerContainer.scrollHeight;
		
		window.addEventListener('resize', () => {
			vh = window.innerHeight * 0.01;
			headerSize = headerContainer.scrollHeight;
		});

		document.documentElement.style.setProperty('--vh', `${vh}px`);
		document.documentElement.style.setProperty('--headerSize', `${headerSize}px`);
	}

	function body_scroll() {
		window.addEventListener(
			'scroll',
			throttle(() => {
				window.scrollY > 100 ? document.body.classList.add('scrolled') : document.body.classList.remove('scrolled');
			}, 150)
		);
	}

	function getUrlParams(search) {
		if (search.length <= 1) return {};
		const hashes = search.slice(search.indexOf('?') + 1).split('&');
		const params = {};
		hashes.map((hash) => {
			const [key, val] = hash.split('=');
			params[key] = decodeURIComponent(val);
		});
		return params;
	}

	return {
		init: init,
		getUrlParams: getUrlParams,
	};
})();
